import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 4", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#00A551", d: "M0 0h6v4H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFD500", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#1A206D", d: "M0 0h6v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#EA2839", d: "M0 0h6v1H0z" }));
const ForwardRef = forwardRef(SvgMu);
const Memo = memo(ForwardRef);
export default Memo;
